import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_SSO_TOKEN, GET_SSO_TOKEN_SUCCESS, GET_SSO_TOKEN_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSsoToken({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/sso-token`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SSO_TOKEN_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SSO_TOKEN_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SSO_TOKEN_ERROR, payload: error });
  }
}

export function* watchGetSsoToken() {
  yield takeEvery(GET_SSO_TOKEN, getSsoToken);
}

function* getSsoTokenSaga() {
  yield all([fork(watchGetSsoToken)]);
}

export default getSsoTokenSaga;
